export const CloseIcon = ({
  width = 11,
  height = 15,
  color = "#94A3B8"
}: {
  width?: number;
  height?: number;
  color?:string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 11 15"
    fill="none"
  >
    <path
      d="M9.36794 4.61797C9.70974 4.27618 9.70974 3.7211 9.36794 3.3793C9.02615 3.03751 8.47107 3.03751 8.12927 3.3793L5.24998 6.26133L2.36794 3.38204C2.02615 3.04024 1.47107 3.04024 1.12927 3.38204C0.787476 3.72383 0.787476 4.27891 1.12927 4.62071L4.0113 7.50001L1.13201 10.382C0.79021 10.7238 0.79021 11.2789 1.13201 11.6207C1.4738 11.9625 2.02888 11.9625 2.37068 11.6207L5.24998 8.73868L8.13201 11.618C8.4738 11.9598 9.02888 11.9598 9.37068 11.618C9.71248 11.2762 9.71248 10.7211 9.37068 10.3793L6.48865 7.50001L9.36794 4.61797Z"
      fill={color}
    />
  </svg>
);
